import { render, staticRenderFns } from "./access-error.vue?vue&type=template&id=728d9f10&scoped=true"
import script from "./access-error.ts?vue&type=script&lang=ts&external"
export * from "./access-error.ts?vue&type=script&lang=ts&external"
import style0 from "./access-error.scss?vue&type=style&index=0&id=728d9f10&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d9f10",
  null
  
)

export default component.exports